import { watch, onBeforeUnmount } from 'vue';

/**
 * Fecha elementos overlay (modal/drawer/popover) quando o usuário pressiona Esc.
 * Usa listener global no document, ativo apenas enquanto `isOpenRef` for truthy.
 */
export function useEscClose(isOpenRef, onClose) {
  const handler = event => {
    if (event.key === 'Escape') onClose();
  };
  watch(
    isOpenRef,
    open => {
      if (open) document.addEventListener('keydown', handler);
      else document.removeEventListener('keydown', handler);
    },
    { immediate: true }
  );
  onBeforeUnmount(() => document.removeEventListener('keydown', handler));
}
